import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

// Global Lenis smooth momentum scroll wrapper
export const SmoothScroll = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Safari is notably less efficient with a continuously animated scroll loop,
    // especially on pages that also use blur, blend modes and parallax. Native
    // scrolling is smoother there and preserves the expected platform behavior.
    const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(
      window.navigator.userAgent
    );

    if (isSafari) {
      document.documentElement.classList.add("is-safari");
      return () => document.documentElement.classList.remove("is-safari");
    }

    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return children;
};
